import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorUnlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M7.5 9.75A.75.75 0 0 1 6.75 9V7.5c0-2.9 2.35-5.25 5.25-5.25h.5A4.75 4.75 0 0 1 17.25 7a.75.75 0 0 1-1.5 0 3.25 3.25 0 0 0-3.25-3.25H12A3.75 3.75 0 0 0 8.25 7.5V9a.75.75 0 0 1-.75.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19 9.25A2.75 2.75 0 0 1 21.75 12v7A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-7A2.75 2.75 0 0 1 5 9.25h14ZM20.25 12c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 12.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorUnlock;
